import { Axiom } from "@axiomhq/js";

const axiomClient = new Axiom({
  token: process.env.NEXT_PUBLIC_AXIOM_TOKEN!,
  // Suppress console.error from CompressionStream failures in Edge Runtime.
  // The SDK catches the error internally and calls onError — silencing it here
  // is safe because it falls back to uncompressed payloads automatically.
  onError: () => { },
});

export default axiomClient;
